import { render } from "./ShowService.vue?vue&type=template&id=2188e4b2"
import script from "./ShowService.vue?vue&type=script&lang=js"
export * from "./ShowService.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__